import { inject } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpContext,
  HttpContextToken
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';

const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export function skipLoaderContext(skip = true) {
  return new HttpContext().set(SKIP_LOADER, skip);
}

const requests: HttpRequest<any>[] = [];

function removeRequest(req: HttpRequest<any>, loaderService: LoaderService) {
  const i = requests.indexOf(req);
  if (i >= 0) {
    requests.splice(i, 1);
  }
  loaderService.isLoading.next(requests.length > 0);
}

// https://www.freakyjolly.com/http-global-loader-progress-bar-using-angular-interceptors/#.YDjNPHUzZhE
export function loaderInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const loaderService = inject(LoaderService);

  if (req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  requests.push(req);

  loaderService.isLoading.next(true);
  return new Observable(observer => {
    const subscription = next(req).subscribe({
      next: event => {
        if (event instanceof HttpResponse) {
          removeRequest(req, loaderService);
          observer.next(event);
        }
      },
      error: err => {
        console.error('LoaderInterceptor', err);
        removeRequest(req, loaderService);
        observer.error(err);
      },
      complete: () => {
        removeRequest(req, loaderService);
        observer.complete();
      }
    });
    // remove request from queue when cancelled
    return () => {
      removeRequest(req, loaderService);
      subscription.unsubscribe();
    };
  });
}
